// Checkout Optionales BIC-Form wenn IBAN nicht DE...
export const fctCheckIbanForBic = () => {
  $('#iban_hide').keyup(() => {
    fctCheckForBic();
  });

  fctCheckForBic();
};

export const fctCheckForBic = () => {
  try {
    const $ibanHide = $('#iban_hide');
    if ($ibanHide.val().length > 2) {
      if ($ibanHide.val().toUpperCase().indexOf('DE') >= 0) {
        $('#bic').hide();
        $("label[for='bic']").hide();
      } else {
        $('#bic').show();
        $("label[for='bic']").show();
      }
    } else {
      $('#bic').hide();
      $("label[for='bic']").hide();
    }
  } catch (e) {
    // No Iban input available
  }
};
